// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"187":"0d0dbb1a","256":"09b31dde","644":"1b28eb21","646":"ae0b779f","889":"28a7b4ba"}[chunkId] + ".js";
};